import { HOME } from '@/sections';

/** Куда вернуться после входа: только внутренний путь, иначе открытый редирект. */
export function safeNext(next: string | null): string {
  return next?.startsWith('/') && !next.startsWith('//') ? next : HOME;
}
